// Brand color configuration based on the logo
export default {
  colors: {
    primary: {
      50: '#f0f7ff',
      100: '#e0efff',
      200: '#b9ddff',
      300: '#7cc2ff',
      400: '#3aa0ff',
      500: '#0080ff', // Main brand blue from logo
      600: '#0066cc',
      700: '#0052a3',
      800: '#003b75',
      900: '#002952',
    },
    secondary: {
      50: '#f5fbf7',
      100: '#e6f7ed',
      200: '#c2ebd4',
      300: '#8cd9b0',
      400: '#4dc282',
      500: '#00ab55', // Green accent from logo
      600: '#009248',
      700: '#00783c',
      800: '#005c2e',
      900: '#003f20',
    },
    accent: {
      500: '#ffb72b', // Yellow accent if needed
      600: '#f59e0b',
    },
    gray: {
      50: '#f9fafb',
      100: '#f3f4f6',
      200: '#e5e7eb',
      300: '#d1d5db',
      400: '#9ca3af',
      500: '#6b7280',
      600: '#4b5563',
      700: '#374151',
      800: '#1f2937',
      900: '#111827',
    }
  },
  // Logo configuration
  logo: {
    main: '/logo.png',
    alt: 'Business Process Automation Solutions Logo',
    placeholder: {
      icon: 'FiZap',
      text: 'Business Process',
      accentText: 'Automation Solutions'
    }
  }
};